import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "database-grid-card__image database-grid-card__image--default"
}
const _hoisted_4 = { class: "database-grid-card__info" }
const _hoisted_5 = { class: "database-grid-card__title" }
const _hoisted_6 = { class: "flex flex--wrap flex--align-center flex--gap-large" }
const _hoisted_7 = ["disabled", "onClick"]
const _hoisted_8 = { class: "database-grid-card__date" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["results-grid", { 'results-grid--loading': $props.loading || $setup.loading_liked_options }])
    }, [
      _createVNode(_TransitionGroup, {
        name: "grid",
        tag: "ul",
        class: "grid grid--xs flex flex--wrap relative mb-32"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: 'database-option-' + option.id,
              class: "grid__item a3-12 f6-6"
            }, [
              _createElementVNode("div", {
                class: "database-grid-card",
                onClick: $event => ($setup.open_gallery( index ))
              }, [
                (option.image_small_url || option.thumbnail_url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: option.image_small_url || option.thumbnail_url,
                      alt: option.title,
                      class: "database-grid-card__image"
                    }, null, 8 /* PROPS */, _hoisted_2))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", _hoisted_5, _toDisplayString(option.related_project[0].title), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["database-grid-card__like-button", [
									$setup.liked_options.includes( parseInt( option.id ) ) ? 'database-grid-card__like-button--liked' : 'database-grid-card__like-button--unliked',
									{ 'database-grid-card__like-button--loading': $setup.loading_likes.includes( option.id ) }
								]]),
                      disabled: $setup.loading_likes.includes( option.id ),
                      onClick: _withModifiers($event => ($setup.toggle_option_like( option.id )), ["stop"])
                    }, _toDisplayString(option.likes ?? 0), 11 /* TEXT, CLASS, PROPS */, _hoisted_7),
                    _createElementVNode("p", _hoisted_8, _toDisplayString($setup.getDate( option.postDate )), 1 /* TEXT */)
                  ])
                ])
              ], 8 /* PROPS */, _hoisted_1)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ], 2 /* CLASS */),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($setup.gallery_options && $setup.gallery_options.length && $setup.show_gallery_modal)
            ? (_openBlock(), _createBlock($setup["DatabaseGalleryModalComponent"], {
                key: 0,
                options: $setup.gallery_options,
                "selected-gallery-index": $setup.selected_gallery_index,
                "liked-options": $setup.liked_options,
                "loading-modal-likes": $setup.loading_modal_likes,
                onSelectPrev: $setup.selectPrevGalleryOption,
                onSelectNext: $setup.selectNextGalleryOption,
                onCloseModal: $setup.close_gallery_modal,
                onUpdateLikes: $setup.toggle_option_like,
                onFetchMoreResults: _cache[0] || (_cache[0] = $event => ($setup.emit( 'fetch-more-results' ))),
                onUpdateDatabaseTags: $setup.updateDatabaseTags
              }, null, 8 /* PROPS */, ["options", "selected-gallery-index", "liked-options", "loading-modal-likes"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}